import { Expose } from 'class-transformer'
import type { MainNavMiscConfig as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'

export type SerializedMainNavMiscConfig = Model

export default class MainNavMiscConfig implements CamelCaseKeys<SerializedMainNavMiscConfig> {
    @Expose({ name: 'hide_gear_menu' })
    hideGearMenu?: Model['hide_gear_menu']

    @Expose({ name: 'hide_organization_settings' })
    hideOrganizationSettings?: Model['hide_organization_settings']

    constructor(values: MainNavMiscConfig) {
        Object.assign(this, values)
    }
}
